import {
  buttonSizeMedium,
  variantContainedSecondaryClasses,
} from 'libs/shared/ui/src/lib/components/button/styles'

export const exitButtonClasses = `${variantContainedSecondaryClasses} ${buttonSizeMedium} rounded cursor-pointer`
export const extraActionButtonClasses =
  'py-3 px-8 rounded font-bold disabled:opacity-75 disabled:text-black disabled:cursor-not-allowed border-2 bg-primary border-primary text-white disabled:bg-gray-400 hover:text-primary hover:border-2 hover:border-primary hover:bg-white hover:fill-white transition-all fill-primary lg:absolute lg:right-0'
